import axios from 'api';

// /api/super/prompt-generator/ — single platform-wide prompt-generator config.
// It is a singleton (no id in the path): GET reads the current row, PATCH
// updates whichever keys you send.
//
//   Connection : base_url, api_key, model, temperature (number), max_tokens (number)
//   Prompts    : orchestrator_prompt, plan_extractor_prompt, compiler_prompt
//
// Session cookie + X-CSRFToken are attached by the shared axios instance
// (withCredentials + xsrfCookieName), so the curl's -b/-H flags have no
// equivalent here.
const BASE = '/api/super/prompt-generator/';

export const getPromptGenerator = (signal) => axios.get(BASE, { signal });

// Body: any subset of the fields above. Send only what changed — PATCH is
// partial, and omitting `api_key` leaves the stored key untouched.
export const updatePromptGenerator = (body) => axios.patch(BASE, body);
